
export default [
	"JmRowActionEdit",
	"JmRowActionDelete"
];



// WEBPACK FOOTER //
// ./src/services/components/actions/location.js